import { FormattedMessage } from "react-intl";

const MultipleInstances = () => {
    return (
        <div>
            <p>
                <FormattedMessage
                    id="JiraSoftwarePricingPageTeam24.features.multipleInstances.content.body"
                    defaultMessage="Enable data isolation and administrative autonomy. Customize each instance to the needs of the teams who use it."
                />
            </p>
        </div>
    );
};

export default MultipleInstances;
